import { put, call, takeEvery } from "redux-saga/effects";
import { safe } from "providers/GeneralProvider/saga";
import {
  getHealthTypeListRequest,
  getHealthTypeListSuccess,
  getHealthTypeListFailure,
  getHealthTypeAllRequest,
  getHealthTypeAllSuccess,
  getHealthTypeAllFailure,
  createHealthTypeRequest,
  createHealthTypeSuccess,
  createHealthTypeFailure,
  updateHealthTypeRequest,
  updateHealthTypeSuccess,
  updateHealthTypeFailure,
  deleteHealthTypeRequest,
  deleteHealthTypeSuccess,
  deleteHealthTypeFailure,
  restoreHealthTypeRequest,
  restoreHealthTypeSuccess,
  restoreHealthTypeFailure,
} from "./slice";
import request from "utils/api";
import Helper from "utils/helpers";

function* getHealthTypeList({ meta, payload }) {
  try {
    const params = {
      page: payload?.page || 1,
      limit: payload?.limit || 100,
    };

    const { data } = yield call(request, "api/health/type", params, {
      method: "GET",
    });

    yield put(getHealthTypeListSuccess(data, meta));
  } catch (error) {
    yield put(getHealthTypeListFailure(error.message, meta));
  }
}

function* getHealthTypeAll({ meta }) {
  try {
    const { data } = yield call(request, "api/health/type-all", {}, {
      method: "GET",
    });

    yield put(getHealthTypeAllSuccess(data, meta));
  } catch (error) {
    yield put(getHealthTypeAllFailure(error.message, meta));
  }
}

function* createHealthType({ meta, payload }) {
  try {
    const { data } = yield call(request, "api/health/type", payload, {
      method: "POST",
    });

    yield put(createHealthTypeSuccess(data, meta));
    Helper.toastr("Thành công", "Đã tạo loại y tế mới", "success");
  } catch (error) {
    yield put(createHealthTypeFailure(error.message, meta));
    Helper.toastr("Lỗi", "Không thể tạo loại y tế", "error");
  }
}

function* updateHealthType({ meta, payload }) {
  try {
    const { _id, ...updateData } = payload;
    const { data } = yield call(request, `api/health/type/${_id}`, updateData, {
      method: "PUT",
    });

    yield put(updateHealthTypeSuccess(data, meta));
    Helper.toastr("Thành công", "Đã cập nhật loại y tế", "success");
  } catch (error) {
    yield put(updateHealthTypeFailure(error.message, meta));
    Helper.toastr("Lỗi", "Không thể cập nhật loại y tế", "error");
  }
}

function* deleteHealthType({ meta, payload }) {
  try {
    yield call(request, `api/health/type/${payload._id}`, {}, {
      method: "DELETE",
    });

    yield put(deleteHealthTypeSuccess({}, meta));
    Helper.toastr("Thành công", "Đã xóa loại y tế", "success");
  } catch (error) {
    yield put(deleteHealthTypeFailure(error.message, meta));
    Helper.toastr("Lỗi", "Không thể xóa loại y tế", "error");
  }
}

function* restoreHealthType({ meta, payload }) {
  try {
    const { data } = yield call(request, `api/health/type/${payload._id}/restore`, {}, {
      method: "PUT",
    });

    yield put(restoreHealthTypeSuccess(data, meta));
    Helper.toastr("Thành công", "Đã khôi phục loại y tế", "success");
  } catch (error) {
    yield put(restoreHealthTypeFailure(error.message, meta));
    Helper.toastr("Lỗi", "Không thể khôi phục loại y tế", "error");
  }
}

function* healthTypeSaga() {
  yield takeEvery(getHealthTypeListRequest.type, safe(getHealthTypeList));
  yield takeEvery(getHealthTypeAllRequest.type, safe(getHealthTypeAll));
  yield takeEvery(createHealthTypeRequest.type, safe(createHealthType));
  yield takeEvery(updateHealthTypeRequest.type, safe(updateHealthType));
  yield takeEvery(deleteHealthTypeRequest.type, safe(deleteHealthType));
  yield takeEvery(restoreHealthTypeRequest.type, safe(restoreHealthType));
}

export default healthTypeSaga;
